import React, { useEffect, useState } from "react";
import axios from "axios";

const BulletTable = () => {
    const [treeData, setTreeData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API}/viewweb/view_bullets`);
                const flatData = res.data.bullet;
                const tree = buildTree(flatData);
                setTreeData(tree);
            } catch (error) {
                console.error("Error fetching bullet data", error);
            }
        };
        fetchData();
    }, []);

    // Build tree from flat data
    const buildTree = (data) => {
        const map = {};
        const roots = [];

        data.forEach(item => {
            map[item.id] = { ...item, children: [] };
        });

        data.forEach(item => {
            if (item.parent_id && map[item.parent_id]) {
                map[item.parent_id].children.push(map[item.id]);
            } else {
                roots.push(map[item.id]);
            }
        });

        return roots;
    };

    // Recursive list builder
    const renderNestedList = (nodes = []) => {
        if (!nodes.length) return null;
        return (
            <ul className="list-[upper-roman] ml-5 space-y-1 w-fit text-left">
                {nodes.map(node => (
                    <li key={node.id}>
                        {node.title}
                        {renderNestedList(node.children)}
                    </li>
                ))}
            </ul>
        );
    };

    // File download renderer
    const renderNestedNodes = (nodes = []) => {
        if (!nodes.length) return null;

        return (
            <ul className="list-none ml-4">
                {nodes.map((node) => (
                    <li key={node.id} className="mb-1">
                        {node.url && <a
                            href={node.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline"
                        >
                            {node.title}
                        </a>}

                        {/* Recurse on children */}
                        {renderNestedNodes(node.children)}
                    </li>
                ))}
            </ul>
        );
    };


    console.log(treeData)

    return (
        <div className="p-6">
            <h1 className="text-xl font-bold mb-4">Proactive Disclosures as per RTI Act 2005</h1>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-300 text-sm">
                    <thead className="bg-gray-100 text-left">
                        <tr>
                            <th className="p-3 border-b w-12">#</th>
                            <th className="p-3 border-b w-2/3">Description</th>
                            <th className="p-3 border-b w-1/3">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {treeData.length > 0 ? (
                            treeData.map((node, index) => (
                                <tr key={node.id} className="align-top hover:bg-gray-50">
                                    <td className="p-3 border-b">{index + 1}</td>
                                    <td className="p-3 border-b whitespace-pre-line">
                                        <div>
                                            <div className="font-medium text-left">{node.title}</div>
                                            {renderNestedList(node.children)}
                                        </div>
                                    </td>
                                    <td className="p-3 border-b">
                                        {node.url && <a
                                            href={node.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 underline"
                                        >
                                            {node.title}
                                        </a>}
                                        {renderNestedNodes(node.children)}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center py-4 text-gray-500">
                                    No data found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BulletTable;
